/**
 * @file Unauthenticated page to unsubscribe robot contact email
 * @author Max van Loosbroek
 */

import React, { useEffect } from "react"
import { History } from 'history'
import Spinner from '../../../common/components/Spinner/Spinner'
import { connect } from "react-redux"
import { useTranslation } from "react-i18next"
import { OfflineNotificationsState } from "../redux/types"
import { unsubscribeRobotContactThunk } from "../redux/reducer"
import ContentTitle from "../../../common/components/ContentTitle/ContentTitle"
import { ContentDiv } from '../../../common/components/ContentText/ContentText'
import ReactMarkdown from 'react-markdown'
import ButtonGroup from "../../../common/components/ButtonGroup/ButtonGroup"
import { makeStyles } from '@material-ui/core'
import Content from "../../../common/components/Content/Content"
import styledComponentsTheme from "../../../common/constants/styledComponentsTheme/styledComponentsTheme"
import Button from "../../../common/components/Button/Button"


const useStyles = makeStyles(() => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    text: {
        marginLeft: '45px !important'
    },
    button: {
        marginTop: 'auto',
        marginBottom: 0
    }
}))

export const UnsubscribeRobotContactComponent = (props: {
    match: any,
    history: History,
    robots: any[],
    user: any,
    unsubscribeRobotContact: ({ robotId, robotContactId, code }: { robotId: string, robotContactId: string, code: string }) => any,
    offlineNotifications: OfflineNotificationsState
}) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const error = props.offlineNotifications.unsubscribeError
    const success = props.offlineNotifications.unsubscribeSuccess
    const accepting = props.offlineNotifications.unsubscribing
    const code = (new URLSearchParams(window.location.search)).get('code')!
    const robotId = (new URLSearchParams(window.location.search)).get('robotId')!
    const robotContactId = (new URLSearchParams(window.location.search)).get('contactId')!

    const inviteAccept = async () => {
        props.unsubscribeRobotContact({ code, robotId, robotContactId })
    }

    useEffect(() => {
        if(error) {
            props.history.push('/error')
        }
    }, [error, props.history])

    useEffect(() => {
        if (!success && !accepting && !error) {
            inviteAccept()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.history, code, accepting])

    const onSubmit = () => {
        window.location.assign("http://www.tinybots.nl")
    }

    let title: string = ''
    let message: string = ''
    let submit: string = ''
    if (success ) {
        title = t('OFFLINE_NOTIFICATIONS.UNSUBSCRIBE_SUCCESS.TITLE')
        message = t('OFFLINE_NOTIFICATIONS.UNSUBSCRIBE_SUCCESS.MESSAGE')
        submit = t('OFFLINE_NOTIFICATIONS.UNSUBSCRIBE_SUCCESS.SUBMIT')
    }

    const backgroundColorButton = styledComponentsTheme.colors.ochre
    const colorButton = styledComponentsTheme.colors.darkgrey

    return <>
        {success && <Content hideNav innerProps={{ className: classes.wrapper }}>
            <ContentTitle className={classes.text}><ReactMarkdown source={title}></ReactMarkdown></ContentTitle>
            <ContentDiv className={classes.text}><ReactMarkdown source={message}></ReactMarkdown></ContentDiv>
            <ButtonGroup className={classes.button}>
                {submit &&
                    <Button id="submit-button-invite" style={{ width: '100%', border: 'none', backgroundColor: backgroundColorButton, color: colorButton }} onClick={onSubmit}>
                        {submit}
                    </Button>
                }
            </ButtonGroup>
        </Content>}
        {!error && !success && <Spinner />}
    </>
}

const mapStateToProps = ({ offlineNotifications }: { offlineNotifications: OfflineNotificationsState }) => ({ offlineNotifications })
export default connect(mapStateToProps, { unsubscribeRobotContact: unsubscribeRobotContactThunk })(UnsubscribeRobotContactComponent)